/**
 * Identifiant du build, injecté par la CI (`ng build --define __APP_VERSION__="\"<sha>\""`).
 * Absent en local et dans les tests : « dev ».
 */
declare const __APP_VERSION__: string | undefined;

export const APP_VERSION: string = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
